"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _mediaQuery = _interopRequireDefault(require("../../styles/media-query"));
const CardDiv = _styled.default.div(_ref => {
  let {
    theme
  } = _ref;
  return (0, _mediaQuery.default)({
    background: theme.colors.white,
    borderRadius: '10px',
    border: `1px solid ${theme.colors.grey[300]}`,
    boxShadow: '0 5px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    width: ['100%', null, '85%', '50%']
  });
});
const CardContentWrapper = _styled.default.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
});
const CardTitle = _styled.default.div(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    fontWeight: theme.fontWeights.semiBold,
    marginBottom: '5px',
    textAlign: 'center'
  };
});

/**
 * A basic card component that has a title and body.
 */
const Card = _ref3 => {
  let {
    children,
    title = ''
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(CardDiv, null, /*#__PURE__*/_react.default.createElement(CardContentWrapper, null, /*#__PURE__*/_react.default.createElement(CardTitle, null, title), children));
};
var _default = exports.default = Card;